var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      style:
        "color:" +
        _vm.textColor +
        ";background-color:" +
        _vm.backgroundColor +
        ";"
    },
    [
      _c("logo", { attrs: { collapse: _vm.isCollapse } }),
      _c(
        "el-scrollbar",
        { attrs: { "wrap-class": "scrollbar-wrapper" } },
        [
          _c(
            "el-menu",
            {
              attrs: {
                "default-active": _vm.activeMenu,
                collapse: _vm.isCollapse,
                "background-color": _vm.backgroundColor,
                "text-color": _vm.textColor,
                "unique-opened": false,
                "active-text-color": _vm.textColor,
                "collapse-transition": false,
                mode: "vertical",
                "menu-trigger": "click"
              }
            },
            _vm._l(_vm.appNavbar, function(route) {
              return _c("menu-item", {
                key: route.path,
                attrs: {
                  item: route,
                  collapse: _vm.isCollapse,
                  "base-path": route.path
                }
              })
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }